import type { MembershipRoleEnum } from '@/api/codegen'

export const CLOUD_WORKER_ROLE_NAME = 'Cloud Worker' as const

export const getRoleLabel = (role: MembershipRoleEnum) => {
  switch (role) {
    case 'owner':
      return 'Owner'
    case 'administrator':
      return 'Admin'
    case 'viewer':
      return 'Viewer'
    case 'member':
      return 'Member'
    default:
      return role
  }
}

export const roles = ['viewer', 'administrator', 'owner', 'member'] as const

const fixedRoles = new Set<MembershipRoleEnum>(['member'])

export const rolesOptions = roles.map((role) => ({
  value: role,
  label: getRoleLabel(role),
  ...(fixedRoles.has(role) ? { isFixed: true } : {}),
}))

/** Role options for filtering: unlike `rolesOptions` no role is pinned. */
export const roleFilterOptions = roles.map((role) => ({
  value: role,
  label: getRoleLabel(role),
}))
